export default __webpack_public_path__ + "static/media/Pot1.f6aeab03.svg";